module.exports = __webpack_public_path__ + "9561c85ad3e535920504ea8ca71a2e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fovPreview/intersection.jpg
// module id = 1652
// module chunks = 5